import { Component, input, output } from '@angular/core';

import { LinkListComponent } from '@valk-nx/components/ui-link-list/src/lib/link-list.component';
import type { LinkListItem } from '@valk-nx/components/ui-link-list/src/lib/link-list.interface';
import { cn } from '@valk-nx/core/lib/core';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	selector: 'vp-bottom-sheet',
	templateUrl: './bottom-sheet.html',
	imports: [SVG_ICON_IMPORTS, LinkListComponent],
})
export class BottomSheetComponent {
	cn = cn;

	isOpen = input<boolean>(false);
	sheetItems = input<LinkListItem[]>([]);
	sheetTitle = input<string>('Sheet title');
	preventNavigation = input<boolean>(false);

	toggleSheet = output<void>();
	itemClicked = output<LinkListItem>();

	toggleEvent() {
		this.toggleSheet.emit();
	}

	onItemClicked(item: LinkListItem) {
		this.itemClicked.emit(item);
		this.toggleEvent();
	}
}
